// eslint-disable-next-line banned-modules
'use strict';

import BaseModel from '@/classes/base.model';
import PassportModel from '@/blocks/elements/b-passport/model';
import CostCodesModel from '@/blocks/elements/b-cost-codes/model';
import BaseCollection from '@/classes/base.collection';

const TravellerModel = BaseModel.extend({

	defaults() {
		return {
			passport: new PassportModel(),
			costCodes: new BaseCollection([], {
				model: CostCodesModel,
			}),
		};
	},

	toJSON(...args) {
		const result = BaseModel.prototype.toJSON.apply(this, args);

		if (result.railBonusCard != null && !result.railBonusCard.number) {
			delete result.railBonusCard;
		}

		delete result.useLang;

		if (result.passport && result.passport.type && result.passport.type.uid.indexOf('.') !== -1) {
			result.passport.type.uid = result.passport.type.uid.split('.')[0];
		}

		if (result.tariff != null && result.tariff.uid !== 'SCHOOL') {
			delete result.schoolTariffConfirmation;
		}

		if (result.passport && result.passport.citizenship && result.passport.citizenship.uid !== 'KZ') {
			delete result.IIN;
		}

		return result;
	},

	initialize() {
		if (!this.has('passport')) {
			this.set('passport', new BaseModel({
				citizenship: STATE.getSettings().generalSettings.defaultCitizenship,
				type: '',
				originCountry: STATE.getSettings().generalSettings.defaultCitizenship,
			}));
		}
		if (this.has('passport')) {
			this.set('phone', {
				cityCode: '',
				countryCode: STATE.getDefaultCountryCode(),
				number: '',
			});
		}
	},

	parse(resp) {
		let temp = resp;
		while (temp && temp.parameters) {
			temp = temp.parameters;
		}
		if (_.isEmpty(temp.costCodes)) {
			delete temp.costCodes;
		}
		const result = Object.assign(
			{},
			temp,
			{
				passport: new PassportModel(temp.passport, {
					parse: true,
				}),
			},
		);
		return result;
	},

});

export default TravellerModel;
